import {ChangeDetectionStrategy, Component, computed, DestroyRef, inject} from '@angular/core';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialog} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TourCardComponent} from '../tour-card/tour-card.component';
import {TourDetailsData, TourDetailsDialogComponent} from '../tour-details-dialog/tour-details-dialog.component';
import {TrackingService} from "../services/tracking.service";
import {Tour} from "../interfaces/tour.model";

@Component({
  selector: 'app-tour-details',
  imports: [TourCardComponent, MatButtonToggleModule, MatProgressSpinnerModule],
  templateUrl: './tour-details.component.html',
  styleUrl: './tour-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourDetailsComponent {
  protected readonly tracking = inject(TrackingService);
  private readonly dialog = inject(MatDialog);

  protected readonly loading = this.tracking.loading;
  protected readonly daysBack = this.tracking.daysBack;
  protected readonly current = this.tracking.current;
  protected readonly lastUpdated = this.tracking.lastUpdated;

  protected readonly tours = computed(() => [...this.tracking.tours()].reverse());

  constructor() {
    inject(DestroyRef).onDestroy(this.tracking.watch());
  }

  protected openDetails(tour: Tour): void {
    this.dialog.open<TourDetailsDialogComponent, TourDetailsData>(TourDetailsDialogComponent, {
      data: {tour, daysBack: this.daysBack()},
      width: '720px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'tour-details-dialog',
    });
  }
}
